import clsx from "clsx";
import React, { FunctionComponent, SVGProps } from "react";

export const CheckIcon: FunctionComponent<SVGProps<SVGSVGElement>> = ({
  className,
  ...props
}) => {
  return (
    <svg
      {...props}
      className={clsx("tw-icon", className)}
      height={18}
      viewBox="0  0 20 18"
      width={20}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        clipRule="evenodd"
        d="M.69 1.19A1.5 1.5 0 0 1 1.75.75h16.5a1.5 1.5 0 0 1 1.5 1.5V16.5a.75.75 0 0 1-1.085.67L16 15.839l-2.665 1.333a.75.75 0 0 1-.67 0L10 15.839 7.335 17.17a.75.75 0 0 1-.67 0L4 15.839 1.335 17.17A.75.75 0 0 1 .25 16.5V2.25c0-.398.158-.78.44-1.06Zm17.56 1.06H1.75v13.037l1.915-.958a.75.75 0 0 1 .67 0L7 15.661l2.665-1.332a.75.75 0 0 1 .67 0L13 15.661l2.665-1.332a.75.75 0 0 1 .67 0l1.915.957V2.25ZM4.375 6.75a.75.75 0 0 1 .75-.75h9.75a.75.75 0 0 1 0 1.5h-9.75a.75.75 0 0 1-.75-.75Zm0 3a.75.75 0 0 1 .75-.75h9.75a.75.75 0 0 1 0 1.5h-9.75a.75.75 0 0 1-.75-.75Z"
        fillRule="evenodd"
      />
    </svg>
  );
};
